export type TCommunicationConfidenceTone = "high" | "medium" | "low";

export const normalizeCommunicationConfidence = (value: number | null | undefined): number => {
  if (typeof value !== "number" || Number.isNaN(value)) {
    return 0;
  }

  return Math.max(0, Math.min(100, Math.round(value)));
};

export const getCommunicationConfidenceTone = (
  confidence: number | null | undefined
): TCommunicationConfidenceTone => {
  const normalizedConfidence = normalizeCommunicationConfidence(confidence);

  if (normalizedConfidence >= 80) {
    return "high";
  }

  if (normalizedConfidence >= 55) {
    return "medium";
  }

  return "low";
};
